/*@flow*/
import * as t from 'lib/t';
import enumList from './enumList';

export default function enumsFor(name: string) {
  let enumArr = enumList[name];
  const coll = enumArr.reduce((s, k) => ({ ...s, [k]: k }), {});
  return t.enums(coll);
}
